<div class="estado-wrapper">
  <div class="header">
    <div class="titulo-box">Sucursales Disponibles</div>

    <div class="contador">
      <div class="contador-box">
        <span class="label">Mostrando</span>
        <span class="numero">
          {{ loading ? '...' : totalSucursales }}
        </span>
      </div>

      <div class="contador-box seleccionadas">
        <span class="label">Seleccionadas</span>
        <span class="numero">
          {{ totalSeleccionadas }}
        </span>
      </div>
    </div>
  </div>

  <div class="alerta">
    <strong>Sugerencia:</strong>
    Selecciona múltiples sucursales para generar una reposición consolidada.
  </div>

  <!-- SKELETON LOADER -->

  <div *ngIf="loading" class="sucursales-grid">
    <div
      class="sucursal-card skeleton"
      *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8]"
    >
      <div class="sucursal-icon skeleton-box"></div>

      <div class="sucursal-info">
        <div class="skeleton-text"></div>
        <div class="skeleton-text small"></div>
      </div>
    </div>
  </div>

  <!-- SUCURSALES REALES -->

  <div *ngIf="!loading" class="sucursales-grid">
    <div
      class="sucursal-card"
      *ngFor="let sucursal of sucursales"
      (click)="toggleSucursal(sucursal)"
      [class.seleccionada]="sucursal.seleccionada"
    >
      <div class="sucursal-icon">
        <img src="assets/layout/images/pharmacy.webp" alt="Sucursal" />
      </div>

      <div class="sucursal-info">
        <span class="codigo">
          {{ sucursal.codigo }}
        </span>

        <span class="nombre">
          {{ sucursal.nombre }}
        </span>
      </div>
    </div>
  </div>

  <div class="acciones-reposicion">
    <div class="botones">
      <button
        pButton
        type="button"
        label="Seleccionar Todos"
        class="p-button-secondary"
        (click)="seleccionarTodos()"
      ></button>

      <button
        pButton
        type="button"
        label="Iniciar Reposición →"
        class="p-button-primary"
        (click)="iniciarReposicion()"
      ></button>
    </div>

    <p class="mensaje-error" *ngIf="errorMensaje">
      {{ errorMensaje }}
    </p>
  </div>
</div>
